import {useState, useCallback, useEffect} from "react";
import {Utils as QbUtils, Query, Builder as AwBuilder} from '@react-awesome-query-builder/ui';
import '@react-awesome-query-builder/ui/css/styles.css';
import '@react-awesome-query-builder/ui/css/compact_styles.css';

const Builder = (props) => {
    const {name, value, config, queryName} = props
    const url = new URL(window.location.href)
    const defaultValue = {id: QbUtils.uuid(), type: "group"}
    const [error, setError] = useState()

    const [state, setState] = useState({
        tree  : QbUtils.checkTree(QbUtils.loadTree(defaultValue), config),
        config: config
    });


    const onRuleChange = useCallback((immutableTree, config) => {
        setState(prevState => ({...prevState, tree: immutableTree, config: config}));
    }, []);


    const renderBuilder = useCallback((props) => {
        return (<div className="query-builder-container">
            <div className="query-builder qb-lite" style={{marginLeft: 0, marginRight: '-10px'}}>
                <AwBuilder {...props} />
            </div>
        </div>)
    }, []);


    useEffect(() => {
        if (value) {
            try {
                setState({
                    tree  : QbUtils.checkTree(QbUtils.loadTree(JSON.parse(value)), config),
                    config: config
                })
            } catch (e) {

            }
        }
    }, [value]);


    return (
        <div>
            <label>Rules: </label>
            <Query {...config} value={state.tree} onChange={onRuleChange} renderBuilder={renderBuilder}/>


            {/*<div style={{width: '100%', height: '200px', overflow: 'scroll'}}>
                {JSON.stringify(state)}
            </div>*/}

            {url.searchParams.get('debug') === "1" && <div className="query-builder-result">
                <div>
                    <pre>{JSON.stringify(QbUtils.mongodbFormat(state.tree, state.config))}</pre>
                    <pre>{JSON.stringify(QbUtils.sqlFormat(state.tree, state.config))}</pre>
                </div>
            </div>}
            <input type="hidden" name={name} value={JSON.stringify(state.tree)}/>
            <input type="hidden" name={queryName} defaultValue={JSON.stringify(QbUtils.mongodbFormat(state.tree, state.config))}/>
        </div>
    );
}

export default Builder;
